// extracted by mini-css-extract-plugin
export default {"container":"style_container__I4SiB","activeCategory":"style_activeCategory__RY3wT"};